import React from "react";
import { useQuery } from 'react-query';
import "./ImageSection.scss";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import rightarrow from '../../Images/chevron.png'

import axios from "axios";
import Image2 from "../../Images/image2.png";
let httpProtocol = process.env.REACT_APP_HTTPPROTOCOL;
let fronturl = process.env.REACT_APP_FRONTURL;


const ImageSection = () => {
  const navigate = useNavigate();
  let backendUrl = process.env.REACT_APP_BACKEND_API;
  const fetchRestaurants = async () => {
    let data = JSON.stringify({
      "page": 1,
      "pageSize": 4
    });
    
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${backendUrl}api/v1/business/getAllRestaurants`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    
    let responseData = await axios.request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
    return responseData?.data?.data;
  };

  const { data, isLoading, error, refetch} = useQuery('restaurants', () => fetchRestaurants());
  const handleErrorImage = (event) => {
    event.target.src = Image2;
  };
  return (
    <Container>
      <div className="image_section_main_wrapper">
        <div className="image_section_upper_wrapper">
          {/* <div className="first_wrapper"></div> */}
          <div className="first_wrapper">What’s Hot? Know Food Trends To Satisfy<br/><span>Your Customers’ Cravings</span></div>
          <div className="second_wrapper">
            {/* <div className="local_text">local</div> */}
            {/* <div className="first_wrapper">What’s Hot? Know Food Trends To Satisfy<span>Your Customers’ Cravings</span></div> */}
          </div>
          <div className="third_wrapper">Analyze food trends, update your menu, and fulfill your customers' desires by being a trendsetter in the culinary industry.</div>
        </div>
        <div className="image_section_middle_wrapper">
          {isLoading  && <h1>Loading ....</h1>}
          {error  && <p className="error">{error.message}</p>}
          {!!data && data.length>0 ?
            data.map((resData, index)=>{
              let contactInfoData = (resData?.contactInfos?.content != undefined)?JSON.parse(resData?.contactInfos?.content):"";
              let linkBusiness = (resData?.slug_subdomain != null) ? httpProtocol + resData?.slug_subdomain : (resData?.slug != null) ? fronturl + resData?.slug: "/";
              if (contactInfoData.length > 0) {
                contactInfoData = JSON.parse(contactInfoData);
              }
              return (
                <div className="image_section_image_wrapper">
                    <a href={linkBusiness} target="_blank" key={resData.id + index}>
                    <img style={{maxHeight:"200px"}} src={backendUrl + 'uploads/'+ resData?.banner} onError={handleErrorImage}/>
                    <div className="overlay">
                      <div className="overlay_inside_wrapper">
                        <div className="text">{resData?.title}</div>
                        <div className="icon"><img src={rightarrow}/></div>
                      </div>
                      <div className="imagesection_text_value">{contactInfoData?.contactInfoAddress}</div>
                    </div>
                    </a>
                </div>
              )
            })
          :""}
        </div>
        <div
          className="image_section_lower_wrapper"
          onClick={() => navigate("/places")}
        >
          <button>Explore the trends</button>
        </div>
      </div>
    </Container>
  );
};

export default ImageSection;
